import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/crm/leads"; 
const apiFeedBackEndPoint=API_BASE_URL_ENV() + "/crm/feedbacks"; 
const apiDropDownEndpoint= API_BASE_URL_ENV() + "/crm/dropdown/Lead"

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
 
    addFeedback=(data)=>{
        return http.post(apiFeedBackEndPoint, data);
    }
    getDropDown=(id)=>{
        if(id){
            return  http.get(`${apiDropDownEndpoint}?sales_rep_ids=${id}`) 
        }else{
            return  http.get(apiDropDownEndpoint) 
        }
    }
  
}
